<template>
    <v-app-bar v-if="$isDesktop()" id="dashboard-core-footer" bottom app fixed clipped-left dark height="40">
        <v-container style="height:100%;">
            <div style="height:100%;display:flex;align-items:center;justify-content:space-between">
                <div v-if="$isDesktop()">
                    <div v-for="(link, i) in links" :key="i">
                        <a :href="link.href" class="mr-0 ml-1" rel="noopener" target="_blank" v-text="link.text" />
                    </div>
                    <v-spacer class="hidden-sm-and-down" />
                </div>

                <div>
                    <div class="font-weight-light  pt-md-0 text-center" style="height:100%;">
                        &copy; 2020-2023 <a :href="CONF_CLIENT_URL" target="_blank">{{ CONF_CLIENT_URL_WRITTEN }}</a> - All rights reserved, made with
                        <v-icon size="18">
                            mdi-heart
                        </v-icon>
                        for a better journey. (<strong>{{ CONF_REVISIONS_NUMBER }} - {{ CONF_SCHEDULER_VERSION }}, {{ CONF_VERSION_NUMBER }}</strong>)
                    </div>
                </div>
            </div>
        </v-container>
    </v-app-bar>
</template>

<script>
    import { mapGetters } from 'vuex';
	import {
        CONF_VERSION_NUMBER,
        CONF_REVISIONS_NUMBER,
        CONF_SCHEDULER_VERSION,
        CONF_CLIENT,
        CONF_CLIENT_URL,
        CONF_CLIENT_URL_WRITTEN,
        CONF_CLIENT_URL_APPS,
        CONF_CLIENT_URL_APPS_WRITTEN
    } from '../../config';


    export default {
        name: 'CoreFooter',

        /* >>> *************************************************************** / /* Data */
        data: () => ({

            links: [
                {
                    href: CONF_CLIENT_URL_APPS,
                    text: CONF_CLIENT_URL_APPS_WRITTEN
                }
            ],
            // >>> -------------------------- CONFIG
            CONF_VERSION_NUMBER: CONF_VERSION_NUMBER,
            CONF_REVISIONS_NUMBER: CONF_REVISIONS_NUMBER,
            CONF_SCHEDULER_VERSION: CONF_SCHEDULER_VERSION,
            CONF_CLIENT: CONF_CLIENT,
            CONF_CLIENT_URL: CONF_CLIENT_URL,
            CONF_CLIENT_URL_WRITTEN: CONF_CLIENT_URL_WRITTEN,
            CONF_CLIENT_URL_APPS: CONF_CLIENT_URL_APPS,
            CONF_CLIENT_URL_APPS_WRITTEN: CONF_CLIENT_URL_APPS_WRITTEN

        }), // eof data()
        /* <<< ****************************************************************/

        /* >>> *************************************************************** / /* computed */
        computed: {

            ...mapGetters([]),

            smAndDown() {
                return window.innerWidth < 960;
            }

        } // eof computed()
        /* <<< ****************************************************************/

    };
</script>

<style lang="sass">
    #dashboard-core-footer
        a
            color: #ffffff
            font-weight: 500
            text-decoration: none
            text-transform: uppercase
</style>

<style scoped>
    .theme--dark.v-sheet {
        background-color: #AB3B7A; /* #AB3B7A, #2d3e52 */
        border-color: #AB3B7A;
    }

    .container {
        padding: 0px;
    }
</style>

